import React, { useEffect } from 'react';
import activeDropdown from './ActiveLink/activeDropdown';
import ActiveLink from './ActiveLink/ActiveLink';
import styles from './header.module.scss';
import HeaderArrow from './icons/HeaderArrow';
import { useRouter } from 'next/router';

type HeaderProps = {
    setBackground: Function;
};

const DesktopHeaderComponent = ({ setBackground }: HeaderProps) => {
    const router = useRouter();
    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 0) {
                setBackground(styles.background);
            } else {
                setBackground(styles.noBackground);
            }
        });
    }, []);

    const goToContactUsClick = () => router.push('/contact');

    return (
        <>
            <div className={styles.navbar}>
                <button className={styles.dropdownMenu}>
                    <span
                        className={`${styles.dropdownNavElement} ${
                            activeDropdown() === 'solutions' ? styles.active : ''
                        }`}
                    >
                        Products
                        <HeaderArrow />
                    </span>
                    <div className={`${styles.dropdownSubmenu} ${styles.productsDropdownSubmenu}`}>
                        <div className={styles.dropdownSubmenuItems}>
                            <ActiveLink href="/insurance-platform">
                                <span>Noria Insurance Platform</span>
                            </ActiveLink>
                        </div>
                    </div>
                </button>

                <button className={styles.dropdownMenu}>
                    <span
                        className={`${styles.dropdownNavElement} ${
                            activeDropdown() === 'services' ? styles.active : ''
                        }`}
                    >
                        Services
                        <HeaderArrow />
                    </span>
                    <div className={`${styles.dropdownSubmenu} ${styles.servicesDropdownSubmenu}`}>
                        <div className={styles.dropdownSubmenuItems}>
                            <ActiveLink href="/services/digital-strategy">
                                <span>Digital Strategy</span>
                            </ActiveLink>
                            <ActiveLink href="/services/transformation-delivery">
                                <span>Transformation Delivery</span>
                            </ActiveLink>
                            <ActiveLink href="/services/software-engineering-and-solution-architecture">
                                <span>Software Engineering & Solution Architecture</span>
                            </ActiveLink>
                            <ActiveLink href="/services/insights-and-analytics">
                                <span>Insights & Analytics</span>
                            </ActiveLink>
                            <ActiveLink href="/services/quality-assurance-and-test-engineering">
                                <span>Quality Assurance & Test Engineering</span>
                            </ActiveLink>
                            <ActiveLink href="/services/cloud-and-devops">
                                <span>Cloud & Devops</span>
                            </ActiveLink>
                            <ActiveLink href="/services/cloud-operations">
                                <span>Cloud Operations</span>
                            </ActiveLink>
                        </div>
                    </div>
                </button>
                <ActiveLink className={styles.navElement} href="/resources">
                    <span
                        className={`${styles.dropdownNavElement} ${
                            activeDropdown() === 'resources' ? styles.active : ''
                        }`}
                    >
                        Insights
                    </span>
                </ActiveLink>
                <button className={styles.dropdownMenu}>
                    <span
                        className={`${styles.dropdownNavElement} ${
                            activeDropdown() === 'about-us' ? styles.active : ''
                        }`}
                    >
                        About
                    </span>
                    <div className={`${styles.dropdownSubmenu} ${styles.aboutDropdownSubmenu}`}>
                        <div className={styles.dropdownSubmenuItems}>
                            <ActiveLink href="/about-us">
                                <span>About Noria</span>
                            </ActiveLink>
                            <ActiveLink href="/about-us/management-team">
                                <span>Management team</span>
                            </ActiveLink>
                            <a href="https://career.noria.no" target="_blank">
                                Join us
                            </a>
                        </div>
                    </div>
                </button>
            </div>
            <button
                className="nv-buton nv-button-primary desktop-only"
                onClick={goToContactUsClick}
            >
                Talk to our team ➔
            </button>
        </>
    );
};

export default DesktopHeaderComponent;
